<template>
  <div class="textColorBlack">
    <div class="border-b pb-3 mb-4 border-gray-500 text-sm">
      <h5>收件人資訊</h5>
    </div>
    <div class="flex flex-wrap text-sm">
      <div class="w-1/3 lg:w-1/4 mb-4">姓名</div>
      <div class="w-2/3 lg:w-3/4 mb-4">{{ shoppingInfo.recipient.name }}</div>
      <div class="w-1/3 lg:w-1/4 mb-4">手機</div>
      <div class="w-2/3 lg:w-3/4 mb-4">
        <p>({{ shoppingInfo.recipient.country_code }}) {{ shoppingInfo.recipient.phone }}</p>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4" v-if="shoppingInfo.recipient.tel">市話</div>
      <div class="w-2/3 lg:w-3/4 mb-4" v-if="shoppingInfo.recipient.tel">
        <p>{{ shoppingInfo.recipient.tel }}</p>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4">收件地址</div>
      <div class="w-2/3 lg:w-3/4 mb-4 lg:flex">
        <p>{{ shoppingInfo.recipient.zip_code  }}{{ shoppingInfo.recipient.city }}{{ shoppingInfo.recipient.district }}</p>
        <p>{{ shoppingInfo.recipient.address }}</p>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4">備註</div>
      <div class="w-2/3 lg:w-3/4 mb-4">
        <p class="whitespace-normal break-all">
          <span v-if="shoppingInfo.school">{{ shoppingInfo.school }}</span>
          <span v-if="shoppingInfo.school && shoppingInfo.remark"> / </span>
          <span v-if="shoppingInfo.remark">{{ shoppingInfo.remark }}</span>
        </p>
      </div>
      <div class="w-full border-b mb-4 border-gray-500 border-dashed"></div>
      <div class="w-1/3 lg:w-1/4 mb-4">發票類型</div>
      <div class="w-2/3 lg:w-3/4 mb-4">
        <span v-if="shoppingInfo.delivery.eGUIType === 2">電子發票-公司</span>
        <span v-else>電子發票-個人</span>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4">載具存取方式</div>
      <div class="w-2/3 lg:w-3/4 mb-4">
        <span v-if="shoppingInfo.delivery.invoice_type === '31'">會員載具</span>
        <span v-if="shoppingInfo.delivery.invoice_type === '32'">自然人憑證條碼</span>
        <span v-if="shoppingInfo.delivery.invoice_type === '33'">手機條碼</span>
        <span v-if="shoppingInfo.delivery.invoice_type === '330'">手機條碼＋紙本電子發票證明聯</span>
        <span v-if="shoppingInfo.delivery.invoice_type === '0'">紙本電子發票證明聯</span>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4" v-if="shoppingInfo.delivery.invoice_type === '32'">自然人憑證條碼</div>
      <div class="w-1/3 lg:w-1/4 mb-4" v-if="shoppingInfo.delivery.invoice_type === '33' || shoppingInfo.delivery.invoice_type === '330'">手機條碼</div>
      <div class="w-2/3 lg:w-3/4 mb-4" v-if="shoppingInfo.delivery.invoice_type === '32' || shoppingInfo.delivery.invoice_type === '33' || shoppingInfo.delivery.invoice_type === '330'">{{ shoppingInfo.delivery.invoice_carrier }}</div>

      <div class="w-1/3 lg:w-1/4 mb-4" v-if="shoppingInfo.delivery.taxName && shoppingInfo.delivery.eGUIType === 2">統一編號</div>
      <div class="w-2/3 lg:w-3/4 mb-4" v-if="shoppingInfo.delivery.taxName && shoppingInfo.delivery.eGUIType === 2">
        <span>{{ shoppingInfo.delivery.taxNum }}</span>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4" v-if="shoppingInfo.delivery.taxName && shoppingInfo.delivery.eGUIType === 2">發票抬頭</div>
      <div class="w-2/3 lg:w-3/4 mb-4" v-if="shoppingInfo.delivery.taxName && shoppingInfo.delivery.eGUIType === 2">
        <span>{{ shoppingInfo.delivery.taxName }}</span>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4" v-if="invoice_type === '3' && invoice_carrier_type === '1' && shoppingInfo.delivery.eGUIType === 0 && !shoppingInfo.delivery.invoice_giving">中獎寄送地址</div>
      <div class="w-2/3 mb-4" v-if="invoice_type === '3' && invoice_carrier_type === '1' && shoppingInfo.delivery.eGUIType === 0 && !shoppingInfo.delivery.invoice_giving">
        <p>{{ shoppingInfo.delivery.invoice_city }}{{ shoppingInfo.delivery.invoice_district }}</p>
        <p>{{ shoppingInfo.delivery.invoice_address }}</p>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4" v-if="shoppingInfo.delivery.invoice_giving">受贈機關/團體</div>
      <div class="w-2/3 mb-4"  v-if="shoppingInfo.delivery.invoice_giving">
        <span>({{ loveData.code }}) {{ loveData.name }}</span>
      </div>
      <div class="w-1/3 lg:w-1/4 mb-4">同意退貨條款</div>
      <div class="w-2/3 lg:w-3/4 mb-4">
        <p class="whitespace-normal">
          {{ shoppingInfo.invoice_auth ? '同意' : '不同意' }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'RecipientInfo',

  props: {
    loveCode: {
      type: Array
    },
    shoppingInfo: {
      type: Object
    },
    invoice_type: {
      type: String
    },
    invoice_carrier_type: {
      type: String
    },
    isOnlyCredit: {
      type: Boolean
    }
  },
  computed: {
    ...mapGetters([
      'authorized',
      'userRole'
    ]),
    loveData () {
      let self = this
      if (self.shoppingInfo.delivery.invoice_donation) {
        let index = self.loveCode.findIndex(x => x.code === self.shoppingInfo.delivery.invoice_donation)
        if (index > -1) {
          return self.loveCode[index]
        } else {
          return self.loveCode[0]
        }
      } else {
        return self.loveCode[0]
      }
    }
  },
  mounted () {
    this.validated()
  },
  methods: {
    validated () {
      let self = this
      if (!self.shoppingInfo.user.name || !self.shoppingInfo.user.phone || !self.shoppingInfo.user.district || !self.shoppingInfo.user.city || !self.shoppingInfo.user.address || !self.shoppingInfo.user.email) {
        self.$router.push({ name: 'index' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.active {
  color: #4a5568 !important;
  border-color: #4a5568 !important;
}
</style>
